import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

firebase.initializeApp({
    apiKey: "AIzaSyC7Tue48K1AfXDuItW7gS6cEMNnKmiDmdU",
    authDomain: "dyslexia-d9e5d.firebaseapp.com",
    projectId: "dyslexia-d9e5d",
    storageBucket: "dyslexia-d9e5d.appspot.com",
    messagingSenderId: "23774076122",
    appId: "1:23774076122:web:2c9d3c0b9edd74638719e3",
    measurementId: "G-89LKYWV6E4"
})

export var auth = false;
export const firestore = firebase.firestore();



